import { GENDERS_SEO, LANGUAGES } from './constants'
import { numDigits } from './helpers'

export function getCityNameByCode(branchCode) {
  switch (branchCode) {
    case 'ALA_BESAGASH':
      return 'Алматы Бесагаш'
    case 'ALA_SUYUNBAI':
      return 'Алматы Суюнбая'
    case 'ALA_APORT':
      return 'Алматы Апорт'
    case 'ASTANA':
      return 'Астана Туран'
    case 'ASTANA_METRO':
      return 'Астана Метро'
    case 'AST_KAR':
      return 'Астана Карагандинка'
    case 'ASTANA_GS':
      return 'Астана (Gold Star)'
    case 'SHYMKENT':
      return 'Шымкент'
    case 'SHYMKENT_AIRPORT':
      return 'Шымкент Аэропорт'
    case 'KARAGANDA':
      return 'Караганда'
    case 'KOSTANAY':
      return 'Костанай'
    case 'PAVLODAR':
      return 'Павлодар'
    case 'OSKEMEN':
      return 'Усть-Каменогорск'
    case 'AKTAU':
      return 'Актау'
    case 'AKTOBE':
      return 'Актобе'
    case 'ATYRAU':
      return 'Атырау'
    case 'KORDA':
      return 'Кызылорда'
    case 'KOKSHETAU':
      return 'Кокшетау'
    case 'PETROPAVL':
      return 'Петропавловск'
    case 'EKIBASTUZ':
      return 'Екибастуз'
    case 'URALSK':
      return 'Уральск'
    case 'SARYAGASH':
      return 'Сарыагаш'
    case 'SEMEY':
      return 'Семей'
    case 'TARAZ':
      return 'Тараз'
    case 'TALDYKURGAN':
      return 'Талдыкорган'
    case 'SHYMKENT_SELECTION':
      return 'Шымкент City'
    case 'KOSTANAY_ANNIVERSARY':
      return 'Костанай'
    default:
      return 'Алматы'
  }
}

export const thousandSeparator = str =>
  str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')

export function validateInput(creditRequest) {
  console.log(creditRequest)

  if (
    creditRequest.clientMobilePhoneNumber ===
    creditRequest.clientWorkPhoneNumber
  ) {
    alert('Личный и рабочий номера должны быть разные!')
    return false
  }

  if (
    creditRequest.branchCode === '' ||
    creditRequest.branchCode === null ||
    creditRequest.branchCode === undefined
  ) {
    alert('Не заполнено поле "Точка продаж"')
    return false
  }

  if (
    creditRequest.creditPurpose === '' ||
    creditRequest.creditPurpose === null ||
    creditRequest.creditPurpose === undefined
  ) {
    alert('Не заполнено поле "Цель кредитования"')
    return false
  }

  if (
    creditRequest.dealerName === '' ||
    creditRequest.dealerName === null ||
    creditRequest.dealerName === undefined
  ) {
    alert('Не заполнено поле "Наименование автосалона"')
    return false
  }

  if (
    creditRequest.totalPrice === '' ||
    creditRequest.totalPrice === null ||
    creditRequest.totalPrice === undefined
  ) {
    alert('Не заполнено поле "Стоимость приобретаемого обьекта"')
    return false
  }

  if (numDigits(creditRequest.totalPrice) > 9) {
    alert(
      '"Стоимость приобретаемого обьекта" превышает максимально допустимое значение'
    )
    return false
  }

  if (
    creditRequest.downPaymentAmount === '' ||
    creditRequest.downPaymentAmount === null ||
    creditRequest.downPaymentAmount === undefined
  ) {
    alert('Не заполнено поле "Сумма первоначального взноса"')
    return false
  }

  if (numDigits(creditRequest.downPaymentAmount) > 9) {
    alert(
      '"Сумма первоначального взноса" превышает максимально допустимое значение'
    )
    return false
  }

  if (
    creditRequest.creditTerm === '' ||
    creditRequest.creditTerm === null ||
    creditRequest.creditTerm === undefined
  ) {
    alert('Не заполнено поле "Срок кредита в месяцах"')
    return false
  }

  if (creditRequest.creditTerm.length > 2) {
    alert('"Срок кредита в месяцах" превышает максимально допустимое значение')
    return false
  }

  if (
    creditRequest.simplifiedFin === '' ||
    creditRequest.simplifiedFin === null ||
    creditRequest.simplifiedFin === undefined
  ) {
    alert('Не заполнено поле "С упрощенным фин. анализом"')
    return false
  }

  if (
    creditRequest.carBrand === '' ||
    creditRequest.carBrand === null ||
    creditRequest.carBrand === undefined
  ) {
    alert('Не заполнено поле "Марка ТС"')
    return false
  }

  if (
    creditRequest.carModel === '' ||
    creditRequest.carModel === null ||
    creditRequest.carModel === undefined
  ) {
    alert('Не заполнено поле "Модель ТС"')
    return false
  }

  if (
    creditRequest.carManufactureCountry === '' ||
    creditRequest.carManufactureCountry === null ||
    creditRequest.carManufactureCountry === undefined
  ) {
    alert('Не заполнено поле "Страна производитель марки ТС"')
    return false
  }

  if (
    creditRequest.carYear === '' ||
    creditRequest.carYear === null ||
    creditRequest.carYear === undefined
  ) {
    alert('Не заполнено поле "Год выпуска"')
    return false
  }

  if (creditRequest.carYear < 1990 || creditRequest.carYear > 2030) {
    alert('Не верно указано значение "Год выпуска"')
    return false
  }

  if (
    creditRequest.carWheel === '' ||
    creditRequest.carWheel === null ||
    creditRequest.carWheel === undefined
  ) {
    alert('Не заполнено поле "Руль"')
    return false
  }

  if (
    creditRequest.carMileage === '' ||
    creditRequest.carMileage === null ||
    creditRequest.carMileage === undefined
  ) {
    alert('Не заполнено поле "Пробег"')
    return false
  }

  if (numDigits(creditRequest.carMileage) > 6) {
    alert('Значение поля "Пробег" превышает максимально допустимое значение')
    return false
  }

  if (
    creditRequest.clientLastname === '' ||
    creditRequest.clientLastname === null ||
    creditRequest.clientLastname === undefined
  ) {
    alert('Не заполнено поле "Фамилия"')
    return false
  }

  if (
    creditRequest.clientFirstname === '' ||
    creditRequest.clientFirstname === null ||
    creditRequest.clientFirstname === undefined
  ) {
    alert('Не заполнено поле "Имя"')
    return false
  }

  if (
    creditRequest.clientIIN === '' ||
    creditRequest.clientIIN === null ||
    creditRequest.clientIIN === undefined
  ) {
    alert('Не заполнено поле "ИИН"')
    return false
  }

  if (creditRequest.clientIIN.length !== 12) {
    alert('"ИИН" должен содержать 12 символов')
    return false
  }

  if (isNaN(creditRequest.clientIIN)) {
    alert('"ИИН" должен содержать только числа')
    return false
  }

  if (
    creditRequest.clientDateOfBirth === 'дд.мм.гггг' ||
    creditRequest.clientDateOfBirth === '' ||
    creditRequest.clientDateOfBirth === null ||
    creditRequest.clientDateOfBirth === undefined
  ) {
    alert('Не заполнено поле "Дата рождения"')
    return false
  }

  if (isNaN(new Date(creditRequest.clientDateOfBirth).getTime())) {
    alert('Не верно указано значение "Дата рождения"')
    return false
  }

  if (
    creditRequest.clientDocumentIssueDate === 'дд.мм.гггг' ||
    creditRequest.clientDocumentIssueDate === '' ||
    creditRequest.clientDocumentIssueDate === null ||
    creditRequest.clientDocumentIssueDate === undefined
  ) {
    alert('Не заполнено поле "Дата выдачи документа"')
    return false
  }

  if (isNaN(new Date(creditRequest.clientDocumentIssueDate).getTime())) {
    alert('Не верно указано значение "Дата выдачи документа"')
    return false
  }

  if (
    creditRequest.clientDocumentExpireDate === 'дд.мм.гггг' ||
    creditRequest.clientDocumentExpireDate === '' ||
    creditRequest.clientDocumentExpireDate === null ||
    creditRequest.clientDocumentExpireDate === undefined
  ) {
    alert('Не заполнено поле "Срок действия документа"')
    return false
  }

  if (isNaN(new Date(creditRequest.clientDocumentExpireDate).getTime())) {
    alert('Не верно указано значение "Срок действия документа"')
    return false
  }

  if (
    creditRequest.clientGender === '' ||
    creditRequest.clientGender === null ||
    creditRequest.clientGender === undefined
  ) {
    alert('Не заполнено поле "Пол"')
    return false
  }

  if (
    creditRequest.clientCitizenship === '' ||
    creditRequest.clientCitizenship === null ||
    creditRequest.clientCitizenship === undefined
  ) {
    alert('Не заполнено поле "Гражданство"')
    return false
  }

  if (
    creditRequest.clientEducationLevel === '' ||
    creditRequest.clientEducationLevel === null ||
    creditRequest.clientEducationLevel === undefined
  ) {
    alert('Не заполнено поле "Образование"')
    return false
  }

  if (
    creditRequest.clientPlaceOfBirth === '' ||
    creditRequest.clientPlaceOfBirth === null ||
    creditRequest.clientPlaceOfBirth === undefined
  ) {
    alert('Не заполнено поле "Место рождения"')
    return false
  }

  if (
    creditRequest.clientResidency === '' ||
    creditRequest.clientResidency === null ||
    creditRequest.clientResidency === undefined
  ) {
    alert('Не заполнено поле "Признак резиденства"')
    return false
  }

  if (
    creditRequest.clientDocumentInfo === '' ||
    creditRequest.clientDocumentInfo === null ||
    creditRequest.clientDocumentInfo === undefined
  ) {
    alert('Не заполнено поле "Вид документа, удостоверяющего личность"')
    return false
  }

  if (
    creditRequest.clientDocumentIssuer === '' ||
    creditRequest.clientDocumentIssuer === null ||
    creditRequest.clientDocumentIssuer === undefined
  ) {
    alert('Не заполнено поле "Орган выдачи документа"')
    return false
  }

  if (
    creditRequest.clientIsPledger === '' ||
    creditRequest.clientIsPledger === null ||
    creditRequest.clientIsPledger === undefined
  ) {
    alert('Не заполнено поле "Залогодатель"')
    return false
  }

  if (
    creditRequest.clientMaritalStatus === '' ||
    creditRequest.clientMaritalStatus === null ||
    creditRequest.clientMaritalStatus === undefined
  ) {
    alert('Не заполнено поле "Социальный статус"')
    return false
  }

  if (
    creditRequest.clientDependentsNumber === '' ||
    creditRequest.clientDependentsNumber === null ||
    creditRequest.clientDependentsNumber === undefined
  ) {
    alert('Не заполнено поле "Количество иждивенцев"')
    return false
  }

  if (numDigits(creditRequest.clientDependentsNumber) > 1) {
    alert(
      'Значение поля "Количество иждивенцев" превышает максимально допустимое значение'
    )
    return false
  }

  if (
    creditRequest.clientChildCount === '' ||
    creditRequest.clientChildCount === null ||
    creditRequest.clientChildCount === undefined
  ) {
    alert('Не заполнено поле "Количество детей"')
    return false
  }

  if (numDigits(creditRequest.clientChildCount) > 1) {
    alert(
      'Значение поля "Количество детей" превышает максимально допустимое значение'
    )
    return false
  }

  if (
    creditRequest.clientAddressRegion === '' ||
    creditRequest.clientAddressRegion === null ||
    creditRequest.clientAddressRegion === undefined
  ) {
    alert('Не заполнено поле "Область"')
    return false
  }

  if (
    creditRequest.clientAddressDistrict === '' ||
    creditRequest.clientAddressDistrict === null ||
    creditRequest.clientAddressDistrict === undefined
  ) {
    alert('Не заполнено поле "Район"')
    return false
  }

  if (
    (creditRequest.clientAddressTown === '' ||
      creditRequest.clientAddressTown === null ||
      creditRequest.clientAddressTown === undefined) &&
    creditRequest.clientAddressRegion.code !== '750000000' &&
    creditRequest.clientAddressRegion.code !== '710000000' &&
    creditRequest.clientAddressRegion.code !== '790000000'
  ) {
    alert('Не заполнено поле "Город"')
    return false
  }

  if (
    creditRequest.clientAddressStreet === '' ||
    creditRequest.clientAddressStreet === null ||
    creditRequest.clientAddressStreet === undefined
  ) {
    alert('Не заполнено поле "Улица"')
    return false
  }

  if (
    creditRequest.clientAddressHouse === '' ||
    creditRequest.clientAddressHouse === null ||
    creditRequest.clientAddressHouse === undefined
  ) {
    alert('Не заполнено поле "Номер дома"')
    return false
  }

  if (
    creditRequest.clientRegistrationAddress === '' ||
    creditRequest.clientRegistrationAddress === null ||
    creditRequest.clientRegistrationAddress === undefined
  ) {
    alert('Не заполнено поле "Адрес регистрации"')
    return false
  }

  if (
    creditRequest.clientRightOfResidence === '' ||
    creditRequest.clientRightOfResidence === null ||
    creditRequest.clientRightOfResidence === undefined
  ) {
    alert('Не заполнено поле "Право проживания"')
    return false
  }

  if (
    creditRequest.clientActualAddress === '' ||
    creditRequest.clientActualAddress === null ||
    creditRequest.clientActualAddress === undefined
  ) {
    alert('Не заполнено поле "Адрес фактического проживания"')
    return false
  }

  if (
    creditRequest.clientMobilePhoneNumber === '' ||
    creditRequest.clientMobilePhoneNumber === null ||
    creditRequest.clientMobilePhoneNumber === undefined
  ) {
    alert('Не заполнено поле "Мобильный телефон"')
    return false
  }

  if (creditRequest.clientMobilePhoneNumber.length !== 16) {
    alert('Некорректно заполнено поле "Мобильный телефон"')
    return false
  }

  if (
    creditRequest.clientWorkPhoneNumber === '' ||
    creditRequest.clientWorkPhoneNumber === null ||
    creditRequest.clientWorkPhoneNumber === undefined
  ) {
    alert('Не заполнено поле "Рабочий телефон"')
    return false
  }

  if (creditRequest.clientWorkPhoneNumber.length !== 16) {
    alert('Некорректно заполнено поле "Рабочий телефон"')
    return false
  }

  if (
    creditRequest.employerFullName === '' ||
    creditRequest.employerFullName === null ||
    creditRequest.employerFullName === undefined
  ) {
    alert('Не заполнено поле "Полное наименование компании/организации"')
    return false
  }

  if (
    creditRequest.employerActivity === '' ||
    creditRequest.employerActivity === null ||
    creditRequest.employerActivity === undefined
  ) {
    alert('Не заполнено поле "Вид деятельности организации"')
    return false
  }

  if (
    creditRequest.jobPositionCategory === '' ||
    creditRequest.jobPositionCategory === null ||
    creditRequest.jobPositionCategory === undefined
  ) {
    alert('Не заполнено поле "Категория занимаемой должности"')
    return false
  }

  if (
    creditRequest.jobPosition === '' ||
    creditRequest.jobPosition === null ||
    creditRequest.jobPosition === undefined
  ) {
    alert('Не заполнено поле "Должность"')
    return false
  }

  if (
    creditRequest.employmentStatus === '' ||
    creditRequest.employmentStatus === null ||
    creditRequest.employmentStatus === undefined
  ) {
    alert('Не заполнено поле "Статус занятости"')
    return false
  }

  if (
    creditRequest.workExperienceInMonths === '' ||
    creditRequest.workExperienceInMonths === null ||
    creditRequest.workExperienceInMonths === undefined
  ) {
    alert('Не заполнено поле "Стаж работы общий (мес)"')
    return false
  }

  if (numDigits(creditRequest.workExperienceInMonths) > 3) {
    alert(
      'Значение поля "Стаж работы общий (мес)" превышает максимальное значение'
    )
    return false
  }

  if (
    creditRequest.workExperienceInMonthsAtLastPosition === '' ||
    creditRequest.workExperienceInMonthsAtLastPosition === null ||
    creditRequest.workExperienceInMonthsAtLastPosition === undefined
  ) {
    alert('Не заполнено поле "Стаж на последнем месте работы (мес)"')
    return false
  }

  if (numDigits(creditRequest.workExperienceInMonthsAtLastPosition) > 3) {
    alert(
      'Значение поля  "Стаж на последнем месте работы (мес)" превышает максимальное значение'
    )
    return false
  }

  if (
    creditRequest.mainIncome === '' ||
    creditRequest.mainIncome === null ||
    creditRequest.mainIncome === undefined
  ) {
    alert('Не заполнено поле "Доходы от основной деятельности"')
    return false
  }

  if (numDigits(creditRequest.mainIncome) > 8) {
    alert(
      'Значение поля "Доходы от основной деятельности" превышает максимально допустимое значение'
    )
    return false
  }

  if (
    creditRequest.spouseIncome === '' ||
    creditRequest.spouseIncome === null ||
    creditRequest.spouseIncome === undefined
  ) {
    alert('Не заполнено поле "Дополнительный доход"')
    return false
  }

  if (numDigits(creditRequest.spouseIncome) > 8) {
    alert(
      'Значение поля "Дополнительный доход" превышает максимально допустимое значение'
    )
    return false
  }

  if (
    creditRequest.contact1Name === '' ||
    creditRequest.contact1Name === null ||
    creditRequest.contact1Name === undefined
  ) {
    alert('Не заполнено поле "ФИО - Контактное лицо #1"')
    return false
  }

  if (
    creditRequest.contact1PhoneNumber === '' ||
    creditRequest.contact1PhoneNumber === null ||
    creditRequest.contact1PhoneNumber === undefined
  ) {
    alert('Не заполнено поле "Номер телефона - Контактное лицо #1"')
    return false
  }

  if (creditRequest.contact1PhoneNumber.length !== 16) {
    alert('Некорректно заполнено поле "Номер телефона - Контактное лицо #1"')
    return false
  }

  if (
    creditRequest.contact1Relationship === '' ||
    creditRequest.contact1Relationship === null ||
    creditRequest.contact1Relationship === undefined
  ) {
    alert('Не заполнено поле "Тип родства - Контактное лицо #1"')
    return false
  }

  if (
    creditRequest.contact2Name === '' ||
    creditRequest.contact2Name === null ||
    creditRequest.contact2Name === undefined
  ) {
    alert('Не заполнено поле "ФИО - Контактное лицо #2"')
    return false
  }

  if (
    creditRequest.contact2PhoneNumber === '' ||
    creditRequest.contact2PhoneNumber === null ||
    creditRequest.contact2PhoneNumber === undefined
  ) {
    alert('Не заполнено поле "Номер телефона - Контактное лицо #2"')
    return false
  }

  if (creditRequest.contact2PhoneNumber.length !== 16) {
    alert('Некорректно заполнено поле "Номер телефона - Контактное лицо #2"')
    return false
  }

  if (
    creditRequest.contact2Relationship === '' ||
    creditRequest.contact2Relationship === null ||
    creditRequest.contact2Relationship === undefined
  ) {
    alert('Не заполнено поле "Тип родства - Контактное лицо #2"')
    return false
  }

  if (
    creditRequest.contact3Name === '' ||
    creditRequest.contact3Name === null ||
    creditRequest.contact3Name === undefined
  ) {
    alert('Не заполнено поле "ФИО - Контактное лицо #3"')
    return false
  }

  if (
    creditRequest.contact3PhoneNumber === '' ||
    creditRequest.contact3PhoneNumber === null ||
    creditRequest.contact3PhoneNumber === undefined
  ) {
    alert('Не заполнено поле "Номер телефона - Контактное лицо #3"')
    return false
  }

  if (creditRequest.contact3PhoneNumber.length !== 16) {
    alert('Некорректно заполнено поле "Номер телефона - Контактное лицо #3"')
    return false
  }

  if (
    creditRequest.contact3Relationship === '' ||
    creditRequest.contact3Relationship === null ||
    creditRequest.contact3Relationship === undefined
  ) {
    alert('Не заполнено поле "Тип родства - Контактное лицо #3"')
    return false
  }

  return true
}

export const convertFromSeo = {
  phone: phone => {
    return `${phone.replace(
      /^(\+7)(\d{3})(\d{3})(\d{2})(\d{2})$/g,
      '8 ($2) $3-$4-$5'
    )}`
  },
  gender: gender => {
    console.log({ gender })
    const found = GENDERS_SEO.find(({ title }) => title === gender)

    return found && found.code
  },
  language: language => {
    const found = LANGUAGES.find(({ title }) => title === language)
    console.log({ found })
    return found && found.code
  }
}

export const isPhoneMask = phone =>
  phone ? /^8 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(phone) : ''
export const isPhoneMaskSeo = phone =>
  phone ? /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(phone) : ''
export const getMaskedPhone = (phoneNumber = '', maskChar = 'X') =>
  phoneNumber.replace(
    /(^8 \(\d{3}\)) \d{3}-\d{2}-(\d{2})/,
    `$1 ${maskChar}${maskChar}${maskChar}-${maskChar}${maskChar}-$2`
  )
export const parseJson = (str, defaultValue = null) => {
  try {
    return JSON.parse(str)
  } catch (e) {
    return defaultValue
  }
}

export const isAlphaNumeric = str => {
  let code, i, len

  for (i = 0, len = str.length; i < len; i++) {
    code = str.charCodeAt(i)
    if (
      !(code > 47 && code < 58) && // numeric (0-9)
      !(code > 64 && code < 91) && // upper alpha (A-Z)
      !(code > 96 && code < 123)
    ) {
      // lower alpha (a-z)
      return false
    }
  }
  return true
}

export const isNumeric = str => {
  let code, i, len

  for (i = 0, len = str.length; i < len; i++) {
    code = str.charCodeAt(i)
    if (
      !(code > 47 && code < 58) // numeric (0-9)
    ) {
      // lower alpha (a-z)
      return false
    }
  }
  return true
}
